import { useLocation as useReactRouterLocation } from 'react-router-dom'

export const useLocation = () => {
  const location = useReactRouterLocation()

  const { pathname } = location

  return { pathname }
}
